module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4NCiAgICA8cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCA5LjMzM2MwIC44Ni0uNjk2IDEuNTU2LTEuNTU2IDEuNTU2SDMuMTExTDAgMTRWMS41NTZDMCAuNjk2LjY5NiAwIDEuNTU2IDBoMTAuODg4QzEzLjMwNCAwIDE0IC42OTYgMTQgMS41NTZ2Ny43Nzd6Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chat-name-icon.svg
// module id = y/Pd
// module chunks = 1